export function isMac(): boolean {
  return /Mac|iPhone|iPad|iPod/.test(navigator.userAgent)
}
